/* eslint-disable no-case-declarations */
/* eslint-disable react/jsx-no-constructed-context-values */
/*
 * Author M. Atoar Rahman
 * Title: Contex API
 * Description: Contex API
 * Date: 15/07/2022
 */

import { createContext, useContext, useState } from 'react';

// Create Context
const ContextAPI = createContext();

export function useSleepingStock() {
    return useContext(ContextAPI);
}

// Provider Component
export function SleepingStockProvider({ children }) {
    const [show, setShow] = useState(false);
    const [data, setData] = useState();
    const [showPdf, setShowPdf] = useState(false);

    return (
        <ContextAPI.Provider
            value={{
                show,
                setShow,
                data,
                setData,
                showPdf,
                setShowPdf,
            }}
        >
            {children}
        </ContextAPI.Provider>
    );
}

export default ContextAPI;
